import { createFileRoute } from "@tanstack/react-router";
import OwnerSecurityPage from "@/pages/OwnerSecurityPage";

export const Route = createFileRoute("/_owner/owner/security")({
  component: OwnerSecurityPage,
});
